<template>
  <div class="students-container">
    <PreLoader v-if="isLoading"/>
    <SuperAdminSchoolHead style="align-items: flex-start" class="sas-head">
        <template v-slot:title><span class="sas-title">{{$t('students')}}</span></template>
      <template v-slot:center>
        <div class="sas-head-center">
            <v-select :items="filterClasses" item-text="classTitle" item-value="id" v-model="selectedClassId"
                      :label="$t('classFilter')" class="select-teacher"
                      :class="{'no-border': selectedFilterClass}" @change="filterByClass" outlined dense
                      style="margin: 0"/>
            <div class="sas-head-center-block">
                <v-text-field outlined dense v-model="search['query']" @keyup.enter="searchStudents"
                              @input="search.query !== '' ? showIcon = true : showIcon = false"
                              style="margin: 0" prepend-inner-icon="mdi-magnify"
                              :append-icon="!showIcon ? '' : 'mdi-close'" @click:append="clearSearch"/>
                <v-btn color="primary" style="height: 40px; margin: 0" class="text-no-wrap" @click="searchStudents">{{$t("search")}}</v-btn>
            </div>
        </div>
      </template>
      <template v-slot:right>
<!--        <SmartBtn2 @onClick="isAddFile = true">-->
<!--          Импорт <img alt="" src="../../assets/images/icons/import.svg" style="padding-bottom: 5px">-->
<!--        </SmartBtn2>-->
          <div class="export-custom">
              <v-btn color="primary" class="generate-btn" v-if="selectedClassId !== ''" @click="generateLoginAndPassword(true)">
                  {{$t("generateLoginAndPas")}}
              </v-btn>
              <div style="display: flex; flex-direction: row; gap: 8px; flex-wrap: wrap; height: max-content">
                  <ExcelJs ref="exportParent" :buttonTitle="$t('exportParents')" :file-name="$t('parentsLogin')" class="export-btn" :headers="exportParentHeaders" :rows="exportParentRows"/>
                  <span class="export-custom-btn" @click="exportStudentParents"></span>
                  <ExcelJs :file-name="exportName" :button-title="$t('export')" :headers="exportHeaders" :rows="exportRows" class="export-btn"/>
                  <!--          <SmartBtn2 @onClick="downloadTemplate">-->
                  <!--            Загрузить шаблон <img alt="" src="../../assets/images/icons/download.svg">-->
                  <!--          </SmartBtn2>-->
              </div>
          </div>

      </template>
    </SuperAdminSchoolHead>
      <div class="table-block">
        <div v-if="selectedClassId === ''" class="more-info" style="display: flex; flex-direction: row; gap: 4px"><v-icon color="orange" size="25px">mdi-information-outline</v-icon><span v-html="$t('login_and_pass_generate')"/></div>
        <SmartTable :current-page="currentPage" :page-size="pageSize" :schools="students" :total-elements="totalElements" :totalPages="totalPages" menu="Students"
                    @deleteStudents="onMassDelete"  @leftClick="onLeftClick" @rightClick="onRightClick">
<!--          <template v-slot:firstItem>-->
<!--            <div class="filter-class" style="align-items: flex-start; gap: 8px">-->
<!--              <v-select :items="filterClasses" item-text="classTitle" item-value="id" v-model="selectedClassId"-->
<!--                        :label="$t('classFilter')" class="select-teacher" :class="{'no-border': selectedFilterClass}"-->
<!--                        @change="filterByClass" outlined dense/>-->
                      <!--          <SmartButton @clicked="onAddStudent">-->
                      <!--            Добавить ученика <img alt="" src="../../assets/images/icons/add-user.svg">-->
                      <!--          </SmartButton>-->
                      <!--          <SmartButton @clicked="openDeleteCourseModal">Отвязать предмет</SmartButton>-->
                      <!--          <SmartButton @clicked="openRefreshClassCourseModal">Обновить уроки</SmartButton>-->
                      <!--          <SmartButton @clicked="toggleRaiseClassModal">Поднять учеников</SmartButton>-->
<!--                      <SmartButton @clicked="generateLoginAndPassword(true)" v-if="selectedClassId !== ''">-->
<!--                          Сгенерировать логин и пароль-->
<!--                      </SmartButton>-->
<!--                <v-btn color="primary" style="height: 40px; margin: 0" class="text-no-wrap"-->
<!--                       v-if="selectedClassId !== ''" @click="generateLoginAndPassword(true)">-->
<!--                    {{$t("generateLoginAndPas")}}-->
<!--                </v-btn>-->
<!--                  </div>-->
<!--              </template>-->
              <template v-slot:head>
<!--                  <th class="top-th"><input v-model="isSelectAll" type="checkbox" @click="selectAll"></th>-->
                  <th>№</th>
                  <th>{{ $t('class') }}</th>
                  <th>{{ $t('full_name') }}</th>
                  <th>{{ $t('birthDate') }}</th>
                  <th>{{ $t('gender') }}</th>
                  <th></th>
                  <th></th>
              </template>

              <template v-slot:body="{ item }">
<!--                  <td><input v-model="item.checked" type="checkbox" v-show="isSelectAll"></td>-->
                  <td>{{ item.index + 1 }}</td>
                  <td>{{ item.classTitle }}</td>
                  <td>{{ item.surname }} {{ item.name }}</td>
                  <td>{{ formatDOB(item.dateOfBirth) }}</td>
                  <td>{{ item.gender === 0 ? 'М' : 'Ж' }}</td>
                  <td><InfoIcon @click="showDetailInfo(item.id)"/></td>
                  <td><img alt="" class="clickable-icons" src="../../assets/images/icons/pen.svg" @click="onEditStudent(item)"/></td>
                  <td><img alt="" class="clickable-icons" src="../../assets/images/icons/trash.svg" @click="onDeleteStudent(item)"></td>
              </template>
          </SmartTable>
      </div>
        <v-dialog id="add-form" v-model="isAddStudentModal" back-close>
            <v-form ref="studentForm" @submit.prevent="checkIsStudentExist" class="student-modal">
                <div class="form-head d-flex">
                    <div style="font-size: 18px; font-weight: 600">{{isStudentEdit ? $t('editStudent') : $t('add_student')}}</div>
                    <img src="../../assets/images/profile-icon.svg" class="avatar-img">
                </div>
                <div class="pin-field" style="margin-top: 16px">
                    <v-text-field outlined dense label="ПИН/ИНН"  v-model="studentObj.pin" placeholder="00000000000000" @blur.native="checkPin" maxlength="14"/>
<!--                    <div class="input-mask">-->
<!--                        <label>ПИН/ИНН</label>-->
                        <!--                                       :disabled="isStudentEdit"-->
<!--                        <v-text-field v-model="studentObj.pin" placeholder="00000000000000"-->
<!--                                      @blur.native="checkPin" maxlength="14"/>-->
<!--                        <masked-input-->
<!--                            v-model="studentObj.pin"-->
<!--                            mask="1.11.11.1111.11111"-->
<!--                            placeholder="0.00.00.0000.00000"-->
<!--                            @blur.native="checkPin"-->
<!--                        />-->
<!--                    </div>-->
                    <div class="pin-error" v-if="!validFirstNum">1-ая цифра должна быть 1 или 2</div>
                    <div class="pin-error" v-if="!validDatePin">со 2-ой по 9-ый должны быть валидными, а последние 5 цифр произвольные</div>
                </div>
                <div>
                    <v-text-field v-model="studentObj.surname" outlined dense :disabled="isStudentEdit" :rules="firstLastNameRule" :label="$t('surname')"/>
                    <v-text-field v-model="studentObj.name" outlined dense :disabled="isStudentEdit" :rules="firstLastNameRule" :label="$t('firstname')"/>
                    <v-text-field v-model="studentObj.middleName" outlined dense :disabled="isStudentEdit" :rules="middleNameRule" :label="$t('middle_name')"/>
<!--                    <v-text-field v-model="studentObj.titleDeclensionRu" outlined dense :label="$t('rusName')"/>-->
<!--                    <v-text-field v-model="studentObj.titleDeclensionKg" outlined dense :label="$t('kgName')"/>-->
                </div>
                <div class="gender-select"
                     style="display: flex; flex-direction: row; justify-content: space-between; align-items: center">
                    <v-radio-group v-model="studentObj.gender" dense :mandatory="false" :rules="required" row style="width: 30%">
                        <v-radio label="М" value="MALE"></v-radio>
                        <v-radio label="Ж" value="FEMALE"></v-radio>
                    </v-radio-group>
                    <div class="input-mask date" style="width: 70%">
                        <label>{{ $t('birthDate') }}</label>
                        <masked-input v-model="studentObj.dateOfBirth" mask="11.11.1111" :placeholder="$t('dayMonthYear')" disabled style="width: 100%"/>
                    </div>
                </div>
                <div>
                    <v-text-field outlined dense @click="modals.birthPlace = true" readonly :label="$t('birthLocation')" v-model="studentObj.placeOfBirth"/>
                </div>
                <div>
                    <v-select outlined dense v-model="studentObj.classId" :disabled="isStudentEdit" :items="classes" :rules="required" item-text="classTitle" item-value="id" :label="$t('class')"/>
                </div>
                <div class="spacer" style="width: 100%">
                    <div class="input-mask">
                        <label v-html="$t('studentPhone')"/>
                        <masked-input style="width: 100%" v-model="studentObj.phone" mask="\0\(111)111111" placeholder="0(555)123456"/>
                    </div>
                </div>
                <div>
                    <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
                        <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                        <v-tab-item>
                            <v-card color="basil" flat style="padding-top: 24px">
                                <div class="pin-field">
                                    <v-text-field outlined dense :label="`ПИН`" v-model="mother.pin" @blur.native="checkPin" maxlength="14"/>
                                    <div class="pin-error" v-if="mother.pin && ['1', '2'].indexOf(mother.pin[0]) === -1">1-ая цифра должна быть 1 или 2</div>
                                </div>
                                <v-text-field outlined dense v-model="mother.surname" :label="$t('surname')"/>
                                <v-text-field outlined dense v-model="mother.name" :label="$t('firstname')"/>
                                <v-text-field outlined dense v-model="mother.middleName" :label="$t('middle_name')" :rules="middleNameRule"/>
                                <div class="input-mask">
                                    <masked-input style="width: 100%" v-model="mother.phone" mask="\0\(111)111111" :lable="$t('phoneNumber')" placeholder="0(555)123456"/>
                                </div>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <v-card color="basil" flat style="padding-top: 24px">
                                <div class="pin-field">
                                    <v-text-field :label="`ПИН`" v-model="father.pin" outlined dense @blur.native="checkPin" maxlength="14"/>
                                    <div class="pin-error" v-if="father.pin && ['1', '2'].indexOf(father.pin[0]) === -1">1-ая цифра должна быть 1 или 2</div>
                                </div>
                                <v-text-field outlined dense v-model="father.surname" :label="$t('surname')"/>
                                <v-text-field outlined dense v-model="father.name" :label="$t('firstname')"/>
                                <v-text-field outlined dense v-model="father.middleName" :label="$t('middle_name')" :rules="middleNameRule"/>
                                <div class="input-mask">
                                <masked-input style="width: 100%" v-model="father.phone" mask="\0\(111)111111" :lable="$t('phoneNumber')" placeholder="0(555)123456"/>
                            </div>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </div>

<!--                <div class="parent">-->
<!--                    <template>-->
<!--&lt;!&ndash;                        v-if="!studentObj.parents.length">&ndash;&gt;-->
<!--                        <span :class="{'active': parentPersonObj.gender === 'FEMALE'}"-->
<!--                              @click="setParentGender('FEMALE')">-->
<!--                            {{$t('mother')}}-->
<!--                        </span>-->
<!--                        <span :class="{'active': parentPersonObj.gender === 'MALE'}"-->
<!--                              @click="setParentGender('MALE')">-->
<!--                            {{$t('father')}}-->
<!--                        </span>-->
<!--                    </template>-->
<!--                    <div class="pin-field">-->
<!--                        <div class="input-mask">-->
<!--                            <label>ПИН/ИНН</label>-->
<!--                            <masked-input v-model="parentPersonObj.pin" mask="1.11.11.1111.11111"-->
<!--                                          placeholder="0.00.00.0000.00000"/>-->
<!--                        </div>-->
<!--                        <div class="pin-error"-->
<!--                             v-if="parentPersonObj.pin && ['1', '2'].indexOf(parentPersonObj.pin[0]) === -1">-->
<!--                            1-ая цифра должна быть 1 или 2-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <v-text-field v-model="parentPersonObj.name" :label="$t('firstname')"/>-->
<!--                    <v-text-field v-model="parentPersonObj.surname" :label="$t('surname')"/>-->
<!--                    <v-text-field v-model="parentPersonObj.middleName" :label="$t('middle_name')"-->
<!--                                  :rules="middleNameRule"/>-->
<!--                </div>-->

<!--                <div>-->
<!--                    <div class="input-mask">-->
<!--                        <label>{{ $t('phoneNumber') }}</label>-->
<!--                        <masked-input v-model="parentPersonObj.phone" mask="\0\(111)111111" placeholder="0(555)123456"/>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="attach-file">
                    <label class="add-file" for="input-file" style="padding: 4px 8px">Прикрепить файл
                        <input type="file" id="input-file" @change="prepareAttachment">
                    </label>
                    <div class="files">
                        <div class="d-flex" v-for="(file, i) in attachFiles" :key="i">
                            <span class="name">{{file.originalTitle}}</span>
                            <TrashIcon @click="deleteAttachment(file.id, i)"/>
                            <img src="../../assets/images/icons/download.svg" class="download-file"
                                 @click="downloadAttachment(file)" v-if="isStudentEdit">
                        </div>
                    </div>
                </div>
                <div class="form-footer">
                    <div class="btn-actions">
                        <v-btn color="red" @click="isAddStudentModal=false">{{ $t('cancel') }}</v-btn>
                        <v-btn color="green" type="submit">{{ $t('save') }}</v-btn>
                    </div>
                </div>
            </v-form>
        </v-dialog>

        <v-dialog v-model="isDeleting" max-width="450">
            <div class="modal-container">
                <h4>Укажите причину удаления</h4>
                <v-select :items="deleteReasons" label="Причина" item-text="title" item-value="value" v-model="deleteStudentObj.reason" outlined dense/>
                <v-text-field label="Комментарий" v-model="deleteStudentObj.comment" outlined dense/>
                <div class="btn-actions">
                    <v-btn color="primary" @click="isDeleting=false">{{ $t('cancel') }}</v-btn>
                    <v-btn color="red" @click="deleteStudent">{{ $t('remove') }}</v-btn>
                </div>
            </div>
        </v-dialog>

        <v-dialog v-model="isMassDeleting" max-width="450">
            <DeletePopup @accept="massDelete" @cancel="isMassDeleting = false"></DeletePopup>
        </v-dialog>
        <v-dialog v-if="isAddFile" id="add-file" v-model="isAddFile" width="546">
            <ImportFile ref="importFile" :type="'students'" @submit="onSubmit"/>
        </v-dialog>

        <!--STUDENT DETAIL MODAL-->
        <v-dialog v-model="showDetailModal" width="546">
            <v-form>
                <div class="form-head head-title">
                    <div style="font-weight: 600; width: 100%; font-size: 18px;" class="text-center" v-html="$t('fullInformation')"/>
                </div>
                <v-text-field :value="studentDetail.username" :label="$t('login') + `/` + $t('password')" readonly outlined dense type="text"/>
                <v-text-field :value="`${studentDetail.surname} ${studentDetail.name} ${studentDetail.middleName || ''}`" :label="$t('full_name')" readonly outlined dense type="text"/>
                <v-text-field :value="studentDetail.phone" label="Телефон" readonly outlined dense type="text"/>
                <template v-if="studentDetail.parents.length">
                    <v-text-field v-for="(parent, i) in studentDetail.parents" :key="i" :value="parent.parentUsername+' / '+parent.parentTitle"
                                  :label="parent.parentType ? $t('mother') : $t('father')" readonly outlined dense type="text"/>
                </template>
<!--                <v-btn color="primary" style="height: 40px; width: 100%; margin: 0" class="text-no-wrap"-->
<!--                       v-show="!studentDetail.genCode" @click="generateStudentCode">-->
<!--                    {{ $t('generateStudentCode') }}-->
<!--                </v-btn>-->
<!--                <button class="generate-code" @click.prevent="generateStudentCode" v-show="!studentDetail.genCode">-->
<!--                    {{ $t('generateStudentCode') }}-->
<!--                </button>-->
<!--                <v-text-field :label="$t('generateStudentCode')" :value="studentDetail.genCode" readonly-->
<!--                              outlined v-show="studentDetail.genCode"/>-->

                <div class="course-titles">
                    <div class="label">{{ $t('courses') }}</div>
                    <div class="student-course" v-for="(course, i) in studentDetail.courses" :key="i">
                        <span>{{ (course[langObj[currentLang]] === null ? $t('notTranslate') : course[langObj[currentLang]]) +' - '+ course.personTitle }}</span>
                        <TrashIcon @click="deleteOneStudentCourse(course.id, i)" v-if="false"/>
                    </div>
                </div>
                <div class="btn-actions">
                    <v-btn color="primary" @click="showDetailModal = false">{{ $t('close') }}</v-btn>
                </div>
            </v-form>
        </v-dialog>

        <!--DELETE COURSE MODAL-->
        <modal name="course-modal" width="600px" height="420px" class="add-course-modal">
            <div class="modal-container">
                <h4 v-html="$t('detachCourse')"/>
                <div>
                    <v-select v-model="studentCourseCreate.classId" :items="students" item-text="classTitle" item-value="classId" :label="$t('class')" @change="onSelectClass"/>
                </div>
                <div class="added-courses">
                    <h4>Добавленные:</h4>
                    <div class="course" v-for="(course, i) in studentDetail.courses" :key="i">
                        <span class="course-title">{{course[langObj[currentLang]] + ' - ' + course.personTitle}}</span>
                        <TrashIcon @click="deleteCourseFromClass(course, i)"/>
                    </div>
                </div>
            </div>
        </modal>

        <!--REFRESH COURSE MODAL-->
        <modal name="refresh-course-modal" width="500px">
            <div class="modal-container">
                <h4 v-html="$t('updateClassLessons')"/>
                <v-form ref="form">
                    <v-select :items="students" :label="$t('class')" item-text="classTitle" item-value="classId" v-model="refreshClass.classId" :rules="required"/>
                    <div class="btn-actions">
                        <v-btn color="red" @click="closeRefreshCourseModal">{{ $t('cancel') }}</v-btn>
                        <v-btn color="green" @click="submitRefreshClassCourse">{{ $t('update') }}</v-btn>
                    </div>
                </v-form>
            </div>
        </modal>

        <!--EXIST GRADE STUDENTS-->
        <modal name="grade-exist-modal" class="grade-exist-modal" height="350px">
            <div class="modal-container">
                <h4 v-html="$t('deleteStudentsQuestion')"/>
                <div class="btn-actions">
                    <v-btn color="red" @click="deleteStudentGrades">{{ $t('remove') }}</v-btn>
                </div>
                <div class="grade-students">
                    <b v-for="(student, i) in existGradeStudents" :key="i">{{ student.surname +' '+ student.name }}</b>
                </div>
            </div>
        </modal>

        <!--RAISE CLASS MODAL-->
        <modal name="raise-class-modal" height="auto">
            <div class="modal-container">
                <h4>Поднять уровень класса у всех учеников?</h4>
                <div class="btn-actions">
                    <v-btn color="red" @click="toggleRaiseClassModal">{{ $t('cancel') }}</v-btn>
                    <v-btn color="green" @click="submitRaiseClass">Поднять</v-btn>
                </div>
            </div>
        </modal>

        <address-select-detailed-modal ref="placeOfBirth" v-model="modals.birthPlace" :modal-title="$t('birthLocation')" :fullPath.sync="studentObj.placeOfBirth"
                                       :address-id.sync="studentObj.addressId" only-village required save-address/>

        <v-dialog v-model="generateModal" name="generate-login-password-modal" height="200px">
            <div class="modal-container">
                <h4>{{ $t('generateLoginAndPasStudent') }}</h4>
                <div class="btn-actions">
                    <v-btn color="primary" @click="generateModal = false">{{ $t('cancel') }}</v-btn>
                    <v-btn color="red" @click="generateLoginAndPassword('')">{{ $t('yes') }}</v-btn>
                </div>
            </div>
        </v-dialog>
    </div>
</template>

<script>
import { limitNumbers } from '@/utils/limit-numbers'
import SuperAdminSchoolHead from '@/components/super-admin/schools/SuperAdminSchoolHead'
import SmartTable from '@/components/table/SmartTable'
import { StudentService } from '@/_services/student.service'
import moment from 'moment'
import { RoleService } from '@/_services/role.service'
import { StudentClassService } from '@/_services/student-class.service'
import { PersonService } from '@/_services/person.service'
import { StudentParentService } from '@/_services/student-parent.service'
import ExcelJs from '@/components/excel-export/ExcelJs'
import ImportFile from '@/components/import-file/ImportFile'
import { FileImportService } from '@/_services/file-import.service'
import DeletePopup from '@/components/delete-popup/DeletePopup'
import SchoolClassService from '@/_services/school-class.service'
import PreLoader from '@/components/preloader/PreLoader'
import StudentCourseService from '@/_services/student-course.service'
import InfoIcon from '@/components/icons/InfoIcon'
import TrashIcon from '@/components/icons/TrashIcon'
import MaskedInput from 'vue-masked-input'
import GradeService from '@/_services/grade.service'
import FileService from '@/_services/file.service'
import { SchoolService } from '@/_services/school.service'
import AddressSelectDetailedModal from '../../components/address/AddressSelectDetailedModal'
const studentService = new StudentService()
const roleService = new RoleService()
const studentClassService = new StudentClassService()
const personService = new PersonService()
const studentParentService = new StudentParentService()
const fileImportService = new FileImportService()
const schoolService = new SchoolService()

export default {
  components: {
    AddressSelectDetailedModal,
    PreLoader,
    DeletePopup,
    ImportFile,
    ExcelJs,
    SuperAdminSchoolHead,
    SmartTable,
    InfoIcon,
    TrashIcon,
    MaskedInput
  },

  data () {
    return {
      tab: null,
      items: [this.$t('mother'), this.$t('father')],
      modals: { birthPlace: false },
      cyrillicRegex: /^[аАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯөӨүҮңҢ ]+$/,
      langObj: {
        ru: 'courseTitle',
        kg: 'courseTitleKG',
        en: 'courseCode'
      },
      firstLastNameRule: [
        v => !!v || this.$t('Обязательное поле'),
        v => !/\d/.test(v) || this.$t('mustBeWithoutNumbers'),
        v => this.cyrillicRegex.test(v) || 'Только кириллица'
      ],
      middleNameRule: [
        v => !/\d/.test(v) || this.$t('mustBeWithoutNumbers'),
        v => this.cyrillicRegex.test(v) || !v || 'Только кириллица'
      ],
      isAddFile: false,
      isMassDeleting: false,
      generateModal: false,
      isSelectAll: false,
      studentObj: {
        address: '',
        avatar: '',
        chronicleYearId: 1,
        classId: 0,
        comeBy: '',
        dateOfBirth: '',
        email: '',
        enabled: true,
        gender: '',
        languageId: '',
        leaveBy: '',
        middleName: '',
        name: '',
        nationality: '',
        password: '',
        phone: '',
        pin: '',
        schoolId: 0,
        surname: '',
        username: '',
        placeOfBirth: '',
        titleDeclensionRu: '',
        titleDeclensionKg: '',
        roles: [
          0
        ],
        addressId: ''
      },
      showIcon: false,
      studentClassObj: {
        active: true,
        chronicleId: 1,
        classId: 0,
        studentId: 0
      },
      mother: {
        pin: '',
        address: '',
        avatar: '',
        dob: '05.05.1980',
        email: '',
        enabled: true,
        gender: 'FEMALE',
        job: '',
        jobPlace: '',
        languageId: '',
        middleName: '',
        name: '',
        password: '',
        phone: '',
        roles: [],
        surname: '',
        username: ''
      },
      father: {
        pin: '',
        address: '',
        avatar: '',
        dob: '05.05.1980',
        email: '',
        enabled: true,
        gender: 'MALE',
        job: '',
        jobPlace: '',
        languageId: null,
        middleName: '',
        name: '',
        password: '',
        phone: '',
        roles: [],
        surname: '',
        username: ''
      },
      parentPersonObj: {
        pin: '',
        address: '',
        avatar: '',
        dob: '05.05.1980',
        email: '',
        enabled: true,
        gender: 'FEMALE',
        job: '',
        jobPlace: '',
        languageId: null,
        middleName: '',
        name: '',
        password: '',
        phone: '',
        roles: [],
        surname: '',
        username: ''
      },
      students: [],
      allStudents: [],
      classes: [],
      classId: 0,
      required: [v => !!v || this.$t('Обязательное поле')],
      isAddStudentModal: false,
      isStudentEdit: false,
      roles: [],
      languages: [],
      menu2: false,
      exportHeaders: [],
      exportRows: [],
      exportParentHeaders: [],
      exportParentRows: [],
      exportName: '',
      currentPage: 1,
      totalElements: 0,
      pageSize: 0,
      isDeleting: false,
      showDetailModal: false,
      studentDetail: {
        courses: [],
        parents: []
      },
      instrCourseObj: {},
      studentCourseCreate: {
        chronicleId: 0,
        classId: 0,
        courseId: 0,
        instructorId: 0
      },
      isLoading: false,
      totalPages: 1,
      filterClasses: [],
      selectedFilterClass: false,
      selectedClassId: '',
      search: {
        query: ''
      },
      refreshClass: {
        schoolId: 0,
        chronicleId: 0,
        classId: 0
      },
      studentIds: {
        longList: []
      },
      existGradeStudents: [],
      parents: [],
      deleteMassiveGradeIds: [],
      deleteReasons: [
        { title: 'В другом городе', value: 'CITY' },
        { title: 'В деревне', value: 'VILLAGE' },
        { title: 'В области', value: 'REGION' },
        { title: 'За границей', value: 'ABROAD' },
        { title: 'В архиве', value: 'ARCHIVE' },
        { title: 'Работает', value: 'WORK' },
        { title: 'Другое', value: 'OTHER' }
      ],
      deleteStudentObj: {
        chronicleId: 0,
        comment: '',
        quarterId: 0,
        reason: ''
      },
      validFirstNum: true,
      validDatePin: true,
      attachFiles: [],
      fileSelect: {},
      formData: new FormData(),
      addPresetObj: {
        chronicleId: 0,
        isClassRaised: true,
        isPreset: true,
        schoolId: 0,
        stepNumber: 4
      }
    }
  },

  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    },
    currentLang () {
      return this.$root.$i18n.locale
    }
  },

  created () {
    this.studentObj.languageId = this.school.languageId
    this.parentPersonObj.languageId = this.school.languageId
    this.studentObj.chronicleYearId = this.school.chronicleId
    this.studentClassObj.chronicleId = this.school.chronicleId
    this.refreshClass.schoolId = this.school.id
    this.refreshClass.chronicleId = this.school.chronicleId
    this.fetchAllClasses()
    this.fetchRoles()
    this.fetchStudents(true, 0)
  },

  mounted () {
    this.items = [
      this.$t('mother'), this.$t('father')
    ]
  },

  methods: {
    limitNumbers: limitNumbers,

    fetchStudents (refreshAll, page) {
      this.isLoading = true
      studentService.getAllBySchool(this.userProfile.schools[0].id, this.search.query, false, page, 10, this.classId).then((res) => {
        if (refreshAll) {
          this.allStudents = JSON.parse(JSON.stringify(res))
        }

        this.totalElements = res.totalElements
        this.pageSize = res.pageSize
        this.totalPages = res.totalPages
        this.currentPage = res.number + 1
        if (res.content) {
          this.students = res.content.map((i, index) => {
            i.index = index
            return i
          })
        } else this.students = []

        // this.students = res
        // this.students = this.students.map((student, i) => ({ ...student, index: i }))
        // this.totalElements = this.students.length
        // this.pageSize = this.students.length
        this.isLoading = false
        this.prepareExport()
        // if (this.selectedClassId) {
        //   this.filterByClass(this.selectedClassId)
        // }
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    filterByClass (klassId) {
      this.classId = klassId
      this.search.query = ''
      this.selectedFilterClass = true
      // if (klassId) {
      this.fetchStudents(false, 0)
      // this.students = this.allStudents.filter((student) => student.classId === klassId)
      // this.students = this.students.map((student, i) => ({ ...student, index: i }))
      // this.totalElements = this.students.length
      this.prepareExport()
      // } else {
      //   this.students = this.allStudents
      //   this.students = this.students.map((student, i) => ({ ...student, index: i }))
      //   this.totalElements = this.students.length
      //   this.prepareExport()
      // }
    },

    clearSearch () {
      this.showIcon = false
      this.search.query = ''
      this.searchStudents()
    },

    searchStudents () {
      this.selectedClassId = ''
      this.fetchStudents(false, 0)
    },

    prepareExport () {
      this.exportHeaders = [this.$t('full_name'), this.$t('class'), this.$t('gender'), this.$t('birthDate'), 'Логин', 'Пароль']

      studentService.getAllBySchool(this.userProfile.schools[0].id, this.search.query, false, 0, this.totalElements, this.classId)
        .then((res) => {
          if (res.content) {
            this.exportRows = res.content.map(i => {
              return [`${i.surname} ${i.name}`, i.classTitle, i.gender ? 'Ж' : 'М', i.dateOfBirth, i.username, i.username]
            })
          } else this.exportRows = []
          // this.students = res
          // this.students = this.students.map((student, i) => ({ ...student, index: i }))
          // this.totalElements = this.students.length
          // this.pageSize = this.students.length
          this.isLoading = false
          // this.prepareExport()
          // if (this.selectedClassId) {
          //   this.filterByClass(this.selectedClassId)
          // }
        }).catch((err) => {
          this.$toast.error(err)
          this.isLoading = false
        })

      // this.exportRows = this.students.map(i => {
      //   return [`${i.surname} ${i.name}`, i.classTitle, i.gender ? 'Ж' : 'М', i.dateOfBirth, i.username]
      // })
      this.exportName = 'Умная школа: Ученики'
    },

    exportStudentParents () {
      this.isLoading = true
      studentParentService.getStudentParentList(this.school.id, this.selectedClassId).then((res) => {
        this.exportParentHeaders = ['ФИО Родителя', 'Логин Родителя', 'Пароль Родителя', 'ФИО ученика']
        this.exportParentRows = res.map((item) => {
          return [`${item.parentTitle + ' ' + item.parentMiddleName}`, item.parentUsername, item.parentUsername, item.studentTitle]
        })
        this.$refs.exportParent.isExport = true
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    formatDOB (date) {
      return moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY')
    },

    selectAll () {
      this.students = this.students.map(i => {
        i.checked = !this.isSelectAll
        return i
      })
    },

    onMassDelete () {
      this.isMassDeleting = true
    },

    massDelete () {
      this.isLoading = true
      this.existGradeStudents = []
      this.deleteMassiveGradeIds = []
      this.studentIds.longList = this.students.filter(i => i.checked).map(i => i.id)
      GradeService.checkStudentsGrade(this.studentIds).then((res) => {
        if (res.length) {
          this.deleteMassiveGradeIds = res.map((grade) => grade.id)
          res.filter((obj, index, selfArr) =>
            index === selfArr.findIndex((el) =>
              (el.studentId === obj.studentId)
            )).forEach((gradeStudent) => {
            this.students.forEach((student) => {
              if (gradeStudent.studentId === student.id) {
                this.existGradeStudents.push(student)
              }
            })
          })
          this.$modal.show('grade-exist-modal')
          this.isLoading = false
          this.isMassDeleting = false
        } else {
          this.deleteMassiveStudents()
        }
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    deleteStudentGrades () {
      this.isLoading = true
      GradeService.deleteStudentGrades({ longList: this.deleteMassiveGradeIds }).then(() => {
        this.deleteMassiveStudents()
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    deleteMassiveStudents () {
      studentService.massDelete(this.studentIds.longList).then(() => {
        this.$toast.success(this.$t('successDeleted'))
        this.isSelectAll = false
        this.fetchStudents(true)
        this.isMassDeleting = false
        this.isLoading = false
        this.$modal.hide('grade-exist-modal')
      }).catch(err => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    showDetailInfo (studentId) {
      this.isLoading = true
      studentService.getDetails(studentId).then((res) => {
        this.studentDetail = res
        this.getStudentCourses(studentId)
        this.showDetailModal = true
      }).catch(err => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    generateStudentCode () {
      this.isLoading = true
      studentService.getGeneratedCode(this.studentDetail.id).then((res) => {
        this.studentDetail.genCode = res.studentCode
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    async getStudentCourses (studentId) {
      await StudentCourseService.getByStudentIdAndChronicle(studentId, this.school.chronicleId).then((res) => {
        this.studentDetail.courses = res
        this.isLoading = false
      }).catch(err => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    onSelectClass (classId) {
      this.isLoading = true
      const studentId = this.students.find((student) => student.classId === classId).id
      this.getStudentCourses(studentId)
    },

    openDeleteCourseModal () {
      this.instrCourseObj = {}
      this.studentDetail.courses = []
      this.studentCourseCreate.classId = ''
      this.$modal.show('course-modal')
    },

    deleteCourseFromClass (courseObj, index) {
      this.isLoading = true
      const removeClassCourse = {
        classId: courseObj.studentClassId,
        instructorCourseDtos: [{
          archived: true,
          courseId: courseObj.courseId,
          personId: courseObj.personId,
          schoolId: this.userProfile.schools[0].id
        }],
        yearId: this.userProfile.schools[0].chronicleId
      }
      StudentCourseService.deleteWithArray(removeClassCourse).then(() => {
        this.studentDetail.courses.splice(index, 1)
        this.$toast.success(this.$t('successfulDelete'))
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    openRefreshClassCourseModal () {
      this.refreshClass.classId = ''
      this.$modal.show('refresh-course-modal')
    },

    submitRefreshClassCourse () {
      if (this.$refs.form.validate()) {
        this.isLoading = true
        StudentCourseService.refreshScheduleCourses(this.refreshClass).then(() => {
          this.$toast.success(this.$t('successfulUpdate'))
          this.isLoading = false
          this.closeRefreshCourseModal()
        }).catch((err) => {
          this.$toast.error(err)
          this.isLoading = false
        })
      }
    },

    closeRefreshCourseModal () {
      this.$modal.hide('refresh-course-modal')
    },

    downloadTemplate () {
      const a = document.createElement('a')
      a.download = 'Шаблон импорта Учеников.xlsx'
      a.href = '/docs/Шаблон_Окуучу.xlsx'
      a.click()
    },

    onDeleteStudent (item) {
      this.studentObj = item
      this.isDeleting = true
      this.deleteStudentObj.chronicleId = this.userProfile.schools[0].chronicleId
      this.deleteStudentObj.quarterId = this.userProfile.schools[0].quarterId
    },

    deleteStudent () {
      if (!this.deleteStudentObj.reason) {
        this.$toast.info('Выберите причину!')
        return
      }
      this.isLoading = true
      studentService._delete(this.studentObj.id, this.deleteStudentObj).then(() => {
        this.isDeleting = false
        this.$toast.success(this.$t('success'))
        this.fetchStudents(true)
      }).catch(err => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    onAddStudent () {
      this.isAddStudentModal = true
      this.isStudentEdit = false
      this.studentObj = { parents: [] }
      this.parentPersonObj.name = ''
      this.parentPersonObj.surname = ''
      this.parentPersonObj.middleName = ''
      this.parentPersonObj.phone = ''
      this.parentPersonObj.gender = 'FEMALE'
      this.attachFiles = []
    },

    onEditStudent (item) {
      this.isLoading = true
      studentService.getDetails(item.id).then(res => {
        this.studentObj.id = item.id
        this.studentObj.classId = item.classId
        this.studentObj.name = item.name
        this.studentObj.surname = item.surname
        this.studentObj.middleName = res.middleName
        this.studentObj.dateOfBirth = res.dateOfBirth
        this.studentObj.gender = item.gender === 0 ? 'MALE' : 'FEMALE'
        this.studentObj.phone = res.phone ? res.phone.replace('+', '') : ''
        this.studentObj.pin = res.pin
        this.studentObj.placeOfBirth = res.placeOfBirth
        this.studentObj.titleDeclensionRu = res.titleDeclensionRu
        this.studentObj.titleDeclensionKg = res.titleDeclensionKg
        this.studentObj.addressId = null
        this.isAddStudentModal = true
        this.isStudentEdit = true
        this.isLoading = false
        this.studentObj.parents = res.parents
        if (res.parents.length !== 0) {
          res.parents.forEach((el) => {
            if (el.parentType === 1) { // 'FEMALE'
              this.mother.surname = el.parentLastName
              this.mother.name = el.parentFirstName
              this.mother.middleName = el.parentMiddleName
              this.mother.phone = el.parentPhone ? el.parentPhone.replace('+', '') : ''
            } else if (el.parentType === 0) { // 'MALE'
              this.father.surname = el.parentLastName
              this.father.name = el.parentFirstName
              this.father.middleName = el.parentMiddleName
              this.father.phone = el.parentPhone ? el.parentPhone.replace('+', '') : ''
            }
          })
          // this.parentPersonObj.surname = res.parents[0].parentLastName
          // this.parentPersonObj.name = res.parents[0].parentFirstName
          // this.parentPersonObj.middleName = res.parents[0].parentMiddleName
          // this.parentPersonObj.gender = res.parents[0].parentType ? 'FEMALE' : 'MALE'
          // this.parentPersonObj.phone = res.parents[0].parentPhone ? res.parents[0].parentPhone.replace('+', '') : ''
        } else {
          this.clearParentsArr()
          // this.parentPersonObj.name = ''
          // this.parentPersonObj.surname = ''
          // this.parentPersonObj.middleName = ''
          // this.parentPersonObj.gender = 'FEMALE'
          // this.parentPersonObj.phone = ''
        }
        this.fetchStudentAttachments()
      }).catch(err => {
        this.isLoading = false
        this.$toast.error(err)
      })
    },

    clearParentsArr () {
      this.mother.name = ''
      this.mother.surname = ''
      this.mother.middleName = ''
      this.mother.phone = ''
      this.mother.pin = ''
      this.father.name = ''
      this.father.surname = ''
      this.father.middleName = ''
      this.father.phone = ''
      this.father.pin = ''
    },

    fetchRoles () {
      roleService.listPageable(0).then(res => {
        this.roles = res
      }).catch(err => console.log(err))
    },

    fetchAllClasses () {
      SchoolClassService.getAllBySchool(this.userProfile.schools[0].id).then((res) => {
        this.classes = res.map(i => {
          i.classTitle = `${i.classLevel} ${i.classLabel} ${i.languageName}`
          return i
        })
        this.filterClasses = JSON.parse(JSON.stringify(this.classes))
        this.filterClasses.unshift({ id: 0, classTitle: this.$t('showAll') })
      })
    },

    getPin () {
      return this.studentObj.pin[0] + '.' + this.studentObj.pin.slice(1, 3) + '.' + this.studentObj.pin.slice(3, 5) +
              '.' + this.studentObj.pin.slice(5, 9) + '.' + this.studentObj.pin.slice(9)
    },

    checkPin () {
      this.validFirstNum = this.studentObj.pin[0] === '1' || this.studentObj.pin[0] === '2'
      this.validDatePin = moment(this.getPin().slice(2, 12), 'DD.MM.YYYY', true).isValid() &&
          this.getPin().slice(13).split('_').length === 1
      if (this.validDatePin) {
        this.studentObj.dateOfBirth = this.getPin().slice(2, 12)
      }
      if (this.validFirstNum) {
        this.studentObj.gender = this.studentObj.pin[0] === '1' ? 'FEMALE' : 'MALE'
        this.$forceUpdate()
      }

      // this.isLoading = true
      // studentService.checkStudentDataByPin(this.studentObj.pin.replaceAll('.', '')).then((res) => {
      //   if (res.pin) {
      //     this.studentObj.name = res.child_firstname
      //     this.studentObj.surname = res.child_lastname
      //     this.studentObj.middleName = res.child_patronymic
      //     this.studentObj.placeOfBirth = res.birth_region
      //     this.parentPersonObj.name = res.mother_firstname
      //     this.parentPersonObj.surname = res.mother_lastname
      //     this.parentPersonObj.middleName = res.mother_patronymic
      //   }
      //   this.isLoading = false
      //   this.$forceUpdate()
      // }).catch(() => {
      //   this.isLoading = false
      // })
    },

    checkIsStudentExist () {
      this.checkPin()
      if (!this.$refs.studentForm.validate() || !this.validFirstNum || !this.validDatePin) {
        return
      }
      if (this.isStudentEdit) {
        this.submitStudent()
        return
      }
      this.isLoading = true
      studentService.getByPin(this.studentObj.pin.replaceAll('.', '')).then((res) => {
        if (res.studentDetailDTO) {
          this.$toast.error('Ученик с таким ПИНом уже существует!')
          this.isLoading = false
        } else {
          this.submitStudent()
        }
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    fetchStudentAttachments () {
      studentService.getAttaches(this.studentObj.id).then((res) => {
        this.attachFiles = res
      }).catch((err) => {
        this.$toast.error(err)
      })
    },

    prepareAttachment (e) {
      this.fileSelect = e.target.files[0]
      this.formData = new FormData()
      if (this.isStudentEdit) {
        this.formData.append('files', this.fileSelect)
        this.submitAttachments(this.studentObj.id)
        return
      }
      this.attachFiles.push({ originalTitle: this.fileSelect.name, file: this.fileSelect })
    },

    submitAttachments (studentId) {
      if (!this.isStudentEdit) {
        this.attachFiles.forEach((item) => this.formData.append('files', item.file))
      }
      studentService.attachFile(studentId, this.formData).then(() => {
        this.$toast.success('Файл прикреплен!')
        if (this.isStudentEdit) {
          this.fetchStudentAttachments()
        }
      }).catch((err) => {
        this.$toast.error(err)
      })
    },

    deleteAttachment (fileId, index) {
      this.attachFiles.splice(index, 1)
      if (this.isStudentEdit) {
        this.isLoading = true
        studentService.deleteFile(fileId).then(() => {
          this.$toast.success(this.$t('successDeleted'))
          this.isLoading = false
        }).catch((err) => {
          this.$toast.error(err)
          this.isLoading = false
        })
      }
    },

    downloadAttachment (file) {
      this.isLoading = true
      FileService.downloadFile(file.fileUrl).then((res) => res.blob()).then((blob) => {
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = file.originalTitle.replace(' ', '')
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        link.remove()
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    submitStudent () {
      this.isLoading = true
      this.search.query = ''
      this.studentObj.pin = this.studentObj.pin.replaceAll('.', '')
      this.parentPersonObj.pin = this.parentPersonObj.pin.replaceAll('.', '')
      this.studentObj.schoolId = this.userProfile.schools[0].id
      this.studentObj.chronicleYearId = this.userProfile.schools[0].chronicleId
      this.studentObj.roles = this.roles.filter(i => i.code === 'ROLE_STUDENT').map(i => i.id)
      const d = {
        classId: this.studentObj.classId,
        dateOfBirth: this.studentObj.dateOfBirth,
        name: this.studentObj.name,
        surname: this.studentObj.surname,
        middleName: this.studentObj.middleName,
        gender: this.studentObj.gender,
        pin: this.studentObj.pin,
        phone: this.studentObj.phone.slice(1).replace(/[(_)]/g, ''),
        id: this.studentObj.id,
        addressId: this.studentObj.addressId,
        placeOfBirth: this.studentObj.placeOfBirth,
        titleDeclensionRu: this.studentObj.titleDeclensionRu,
        titleDeclensionKg: this.studentObj.titleDeclensionKg
      }
      this.parents.length = 0
      if (this.mother.name !== '') this.parents.push(this.mother)
      if (this.father.name !== '') this.parents.push(this.father)
      this.parents.forEach((el) => {
        if (this.isStudentEdit) {
          studentService.edit(d).then(res => {
            this.isAddStudentModal = false
            this.fetchStudents(true)
            studentClassService.getByStudent(d.id).then(res => {
              this.studentClassObj.classId = this.studentObj.classId
              this.studentClassObj.studentId = this.studentObj.id
              if (res.length) {
                this.studentClassObj.id = res[0].id
                return studentClassService.edit(this.studentClassObj)
              } else {
                return studentClassService.create(this.studentClassObj)
              }
            }).then(res => {
              el.roles = this.roles.filter(i => i.code === 'ROLE_PARENT').map(i => i.id)
              return studentParentService.getByStudent(this.studentObj.id)
            }).then(res => {
              el.phone = el.phone.slice(1).replace(/[(_)]/g, '')
              // if (res._embedded) { // .studentParentResourceList[el.gender === 'FEMALE' ? 0 : 1]) {
              //     if (el.gender === 'MALE') el.id = res._embedded.studentParentResourceList.find(parnt => parnt.parentalType === 'FATHER').parentId
              //     else if (el.gender === 'FEMALE') el.id = res._embedded.studentParentResourceList.find(parnt => parnt.parentalType === 'MOTHER').parentId
              // el.id = res._embedded.studentParentResourceList[el.gender === 'MALE' ? 0 : 1].parentId
              // return personService.edit(el)}
              if ((el.gender === 'MALE' && res._embedded) &&
                    res._embedded.studentParentResourceList.find(parnt => parnt.parentalType === 'FATHER')) {
                el.id = res._embedded.studentParentResourceList.find(parnt => parnt.parentalType === 'FATHER').parentId
                return personService.edit(el)
              } else if ((el.gender === 'FEMALE' && res._embedded) &&
                    res._embedded.studentParentResourceList.find(parnt => parnt.parentalType === 'MOTHER')) {
                el.id = res._embedded.studentParentResourceList.find(parnt => parnt.parentalType === 'MOTHER').parentId
                return personService.edit(el)
              } else {
                return personService.create(el).then(res => {
                  const studentParent = {
                    personId: parseInt(res.message),
                    parentalType: el.gender === 'MALE' ? 'FATHER' : 'MOTHER',
                    studentId: this.studentClassObj.studentId
                  }
                  return studentParentService.create(studentParent)
                }).catch(err => this.$toast.error(err))
              }
            }).then(res => {
              this.$toast.success(this.$t('success'))
              this.isLoading = false
            }).catch(err => this.$toast.error(err))
          }).catch(err => this.$toast.error(err))
        } else {
          this.studentObj.phone = this.studentObj.phone.slice(1).replace(/[(_)]/g, '')
          studentService.create(this.studentObj).then((res) => {
            const studentId = parseInt(res.message)
            this.studentClassObj.classId = this.studentObj.classId
            this.studentClassObj.studentId = studentId
            if (this.attachFiles.length) {
              this.submitAttachments(studentId)
            }
            studentClassService.create(this.studentClassObj).then((res) => {
              this.fetchStudents(true)
              this.isAddStudentModal = false
              this.$toast.success(this.$t('success'))
              this.isLoading = false
            }).catch(err => {
              this.$toast.error(err)
              this.isLoading = false
            })
            el.roles = this.roles.filter(i => i.code === 'ROLE_PARENT').map(i => i.id)
            el.phone = el.phone.slice(1).replace(/[(_)]/g, '')
            personService.create(el).then((res) => {
              const studentParent = {
                personId: parseInt(res.message),
                parentalType: el.gender === 'MALE' ? 'FATHER' : 'MOTHER',
                studentId: this.studentClassObj.studentId
              }
              studentParentService.create(studentParent).then((res) => {
              }).catch(err => {
                this.$toast.error(err)
                this.isLoading = false
              })
            }).catch(err => {
              this.$toast.error(err)
              this.isLoading = false
            })
          }).catch(err => {
            this.$toast.error(err)
            this.isLoading = false
          })
        }
      })
      // this.clearParentsArr()
      // if (this.isStudentEdit) {
      //   studentService.edit(d).then(res => {
      //     this.isAddStudentModal = false
      //     this.fetchStudents(true)
      //
      //     studentClassService.getByStudent(d.id).then(res => {
      //       this.studentClassObj.classId = this.studentObj.classId
      //       this.studentClassObj.studentId = this.studentObj.id
      //       if (res.length) {
      //         this.studentClassObj.id = res[0].id
      //         return studentClassService.edit(this.studentClassObj)
      //       } else {
      //         return studentClassService.create(this.studentClassObj)
      //       }
      //     }).then(res => {
      //       this.parentPersonObj.roles = this.roles.filter(i => i.code === 'ROLE_PARENT').map(i => i.id)
      //       return studentParentService.getByStudent(this.studentObj.id)
      //     }).then(res => {
      //       this.parentPersonObj.phone = this.parentPersonObj.phone.slice(1).replace(/[(_)]/g, '')
      //       if (res._embedded) {
      //         this.parentPersonObj.id = res._embedded.studentParentResourceList[0].parentId
      //         return personService.edit(this.parentPersonObj)
      //       } else {
      //         return personService.create(this.parentPersonObj).then(res => {
      //           const studentParent = {
      //             personId: parseInt(res.message),
      //             parentalType: this.parentPersonObj.gender === 'MALE' ? 'FATHER' : 'MOTHER',
      //             studentId: this.studentClassObj.studentId
      //           }
      //           return studentParentService.create(studentParent)
      //         }).catch(err => this.$toast.error(err))
      //       }
      //     }).then(res => {
      //       this.$toast.success(this.$t('success'))
      //       this.isLoading = false
      //     }).catch(err => this.$toast.error(err))
      //   }).catch(err => this.$toast.error(err))
      // } else {
      //   this.studentObj.phone = this.studentObj.phone.slice(1).replace(/[(_)]/g, '')
      //   studentService.create(this.studentObj).then((res) => {
      //     const studentId = parseInt(res.message)
      //     this.studentClassObj.classId = this.studentObj.classId
      //     this.studentClassObj.studentId = studentId
      //     if (this.attachFiles.length) {
      //       this.submitAttachments(studentId)
      //     }
      //     studentClassService.create(this.studentClassObj).then((res) => {
      //       this.fetchStudents(true)
      //       this.isAddStudentModal = false
      //       this.$toast.success(this.$t('success'))
      //       this.isLoading = false
      //     }).catch(err => {
      //       this.$toast.error(err)
      //       this.isLoading = false
      //     })
      //
      //     this.parentPersonObj.roles = this.roles.filter(i => i.code === 'ROLE_PARENT').map(i => i.id)
      //     this.parentPersonObj.phone = this.parentPersonObj.phone.slice(1).replace(/[(_)]/g, '')
      //     personService.create(this.parentPersonObj).then((res) => {
      //       const studentParent = {
      //         personId: parseInt(res.message),
      //         parentalType: this.parentPersonObj.gender === 'MALE' ? 'FATHER' : 'MOTHER',
      //         studentId: this.studentClassObj.studentId
      //       }
      //       studentParentService.create(studentParent).then((res) => {
      //         console.log(res.message)
      //       }).catch(err => {
      //         this.$toast.error(err)
      //         this.isLoading = false
      //       })
      //     }).catch(err => {
      //       this.$toast.error(err)
      //       this.isLoading = false
      //     })
      //   }).catch(err => {
      //     this.$toast.error(err)
      //     this.isLoading = false
      //   })
      // }
    },

    toggleRaiseClassModal () {
      this.$modal.toggle('raise-class-modal')
    },

    submitRaiseClass () {
      this.isLoading = true
      const presetObj = { chronicleId: this.school.chronicleId, schoolId: this.school.id }
      schoolService.presetCheck(presetObj).then((res) => {
        if (Object.values(res).length) {
          this.$toast.info('На текущий год, классы уже подняты!')
          this.toggleRaiseClassModal()
          this.isLoading = false
          return
        }
        studentService.raiseAllClassLevels(this.school.id, this.school.chronicleId).then(() => {
          this.addPresetObj.schoolId = this.school.id
          this.addPresetObj.chronicleId = this.school.chronicleId
          schoolService.presetCreate(this.addPresetObj).then(() => {
            this.$toast.success('Все классы учеников подняты на один уровень!')
            this.toggleRaiseClassModal()
            this.fetchStudents(true)
          }).catch((err) => {
            this.$toast.error(err)
          })
        }).catch((err) => {
          this.$toast.error(err)
        })
      }).catch((err) => {
        this.$toast.error(err)
      })
    },

    onLeftClick () {
      this.currentPage--
      this.fetchStudents(true, this.currentPage - 1)
    },

    onRightClick () {
      this.currentPage++
      this.fetchStudents(true, this.currentPage - 1)
    },

    onSubmit (data) {
      if (this.$refs.importFile.$refs.importForm.validate()) {
        this.isLoading = true
        const d = {
          chronicleId: data.chronicleId,
          languageId: data.languageId,
          file: data.file,
          schoolId: this.userProfile.schools[0].id
        }
        if (data.isIsouMode) {
          fileImportService.importIsouStudent(d).then(res => {
            this.$toast.success(this.$t('success'))
            this.isAddFile = false
            this.fetchStudents(true)
            this.isLoading = false
          }).catch(err => {
            this.isLoading = false
            this.$toast.error(err)
          })
        } else {
          fileImportService.importStudent(d).then(res => {
            this.$toast.success(this.$t('success'))
            this.isAddFile = false
            this.fetchStudents(true)
            this.isLoading = false
          }).catch(err => {
            this.$toast.error(err)
            this.isLoading = false
          })
        }
      }
    },

    deleteOneStudentCourse (studentCourseId, index) {
      this.isLoading = true
      StudentCourseService.removeStudCourse(studentCourseId).then(() => {
        this.studentDetail.courses.splice(index, 1)
        this.isLoading = false
        this.$toast.success(this.$t('successDeleted'))
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    generateLoginAndPassword (confirm) {
      if (confirm) {
        // this.$modal.show('generate-login-password-modal')
        this.generateModal = true
      } else {
        this.isLoading = true
        studentService.generateLoginPassword(this.userProfile.schools[0].id, this.classId).then(() => {
          // this.$modal.hide('generate-login-password-modal')
          this.generateModal = false
          this.$toast.success('Успешно сгенерировано!')
          this.fetchStudents(true)
        }).catch((err) => {
          this.$toast.error(err)
          this.isLoading = false
        })
      }
    }

    // setParentGender (gender) {
    //   this.parentPersonObj.gender = gender
    // },
  }
}
</script>

<style lang="scss">
.students-container {
    margin-bottom: 50px;
    .filter-class {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .select-class {
            max-width: 185px;
            margin-right: 20px;
            .v-select__slot {
                border: 1px solid #9E9E9E;
                border-bottom: 0;
                .v-label {
                    padding: 0 8px;
                }
            }
            &.no-border {
                .v-select__slot {
                    border: 0;
                }
            }
        }
        .smart-btn {
            margin-left: 18px;
        }
    }

    .add-course-modal {
        .modal-container {
            height: 100%;
            overflow-y: auto;
            .added-courses {
                .course {
                    display: flex;
                    align-items: center;
                    &:not(:last-child) {
                        border-bottom: 1px solid #c7c6c6;
                        padding: 5px 0;
                    }
                    .course-title {
                        width: 92%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        margin-right: 10px;
                    }
                }
            }
        }
    }
}

.course-titles {
    margin-top: 18px;
    .label {
        font-size: 13px;
        color: #838080;
    }
    .student-course {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #b4b4b4;
        margin-bottom: 7px;
    }
}

.head-title {
    margin-bottom: 20px;
}

.v-form {
    background: #FFFFFF;
    border-radius: 7px;
    padding: 20px 40px;

    div.form-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;

        .v-input--radio-group {
            margin-right: 20px;
        }

        .profile-edit {
            background: #FFFFFF;
            box-shadow: 0 4px 4px rgba(0, 0, 0, 0.08);
            width: 24px;
            height: 24px;
            border-radius: 50%;
            position: absolute;
            right: 0;
            bottom: 0;

            img {
                margin-top: 5px;
            }
        }

        &.spacer {
            .v-text-field:first-child {
                margin-right: 20px;
            }
        }
    }
    .generate-code {
        background: #1976d2;
        color: #fff;
        padding: 0 5px;
        border-radius: 5px;
        width: 100%;
        text-align: center;
    }
    .parent {
        span {
            border: 1px solid #7d7d7d;
            font-size: 14px;
            padding: 10px 15px;
            border-radius: 4px;
            cursor: pointer;
            display: inline-block;
            margin: 0 5px 5px 0;
            &.active {
                background: #1976d2;
                color: #fff;
                cursor: default;
            }
        }
    }
    .attach-file {
        .add-file {
            background: #557fff;
            color: #fff;
            padding: 2px 7px;
            font-size: 13px;
            border-radius: 4px;
            cursor: pointer;
        }
        #input-file {
            display: none;
        }
        .files {
            margin-top: 15px;
            .name {
                max-width: 95%;
                white-space: nowrap;
                overflow-x: hidden;
                text-overflow: ellipsis;
            }
            .delete-icon {
                margin: 2px 8px 0 10px;
            }
        }
        .download-file {
            width: 13px;
            cursor: pointer;
        }
    }
}

.top-th {
    width: 60px;
}

.grade-exist-modal {
    .modal-container {
        height: 100%;
        overflow-y: auto;
        .grade-students {
            text-align: center;
            b {
                display: block;
                font-size: 18px;
                padding: 3px 0;
            }
        }
        .btn-actions {
            margin: 20px 0;
        }
    }
}

.gender-select {
    pointer-events: none;
}
.sas-btn{
    display: none;
}
.select-teacher{
    margin: 0!important;
}
.export-custom{
    display: flex;
    flex-direction: row;
    gap: 8px!important;
    margin: 0;
    padding: 0!important;
}
.generate-btn{
    height: 40px!important; margin: 0;
}
.sas-head-center-block{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: 8px;
    margin: 0!important;
    padding: 0!important;
}
.more-info{
    padding: 0 30px; font-size: 14px;
}
@media (max-width: 420px) {
    .more-info{
        padding: 4px;
        background: rgba(255, 165, 0, 0.13);
        border-radius: 5px;
    }
    .table-block{
        display: flex;
        flex-direction: column;
        padding: 10px;
        gap: 10px;
        text-align: center;
    }
    .sas-head-center-block{
        width: 100%;
        gap: 8px;
    }
    .generate-btn{
        width: 100%;
    }
    .export-btn{
        width: 100%
    }
    .sas-btn{
        display: flex;
    }
    .sas-head{
        flex-wrap: wrap;
        margin: 0!important;
        align-items: center;
        justify-content: center!important;
    }
    .sas-head-center {
        flex-wrap: wrap-reverse;
        justify-content: center;
        padding: 0;
    }
    .sas-title {
        font-size: 20px!important;
    }
    .export-custom{
        flex-wrap: wrap;
        //padding: 12px 0;
        margin: 0;
        width: 100%;
    }
    .select-teacher {
        width: 100%;
    }
    .v-btn__content{
        font-size: 11px!important;
    }
    .alert-parent[data-v-a356e2a2] {
        padding: 10px!important;
    }
    .student-modal{
        width: 100%;
    }
    .v-form {
        padding: 20px;
    }
    .avatar-img{
        width: 75px;
    }
}
</style>
